import { grey } from '@material-ui/core/colors';

export default () => ({
  more: {
    color: grey[800],
    fontSize: 10,
    lineHeight: 1,
  },
});
